import { render, staticRenderFns } from "./editBasePlan.vue?vue&type=template&id=38b183fa&scoped=true&"
import script from "./editBasePlan.vue?vue&type=script&lang=js&"
export * from "./editBasePlan.vue?vue&type=script&lang=js&"
import style0 from "./editBasePlan.vue?vue&type=style&index=0&id=38b183fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b183fa",
  null
  
)

export default component.exports